// extracted by mini-css-extract-plugin
export default {"container":"PromoCodeExists-module__container--EwVjG","title":"PromoCodeExists-module__title--_hQZc","text":"PromoCodeExists-module__text--k9Jly"};